import { useForm } from "react-hook-form";
import { CustomFormField } from "../../../../../utilis/component/CustomFormElement";
import {
  CircularProgress,
  IconButton,
  Table,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import CustomTableBody from "../../../../../utilis/component/CustomTableBody";
import { Fragment, useEffect, useState } from "react";
import { useMutation } from "react-query";
import moment from "moment";
import { NoteAdd } from "@mui/icons-material";
import debounce from "../../../../../utilis/methods/networkHandling";
import { FormOnChangeEventType } from "../../../../../EMR/types";
import { useNavigate } from "react-router-dom";
import { base } from "../../../../../constants";
import moduleRoutes from "../../../../../routes/moduleRouteList";
import patientCareRouteList from "../../../../routeList";
import { getbilledItemPayloadType } from "../../type";
import { getBilledItemService } from "../../Service";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { getBillPrint, getBillPrintV2 } from "../../../../../PatientCare/Billing/services";
import usePrint from "@hooks/usePrint";
import useAuthentication from "@hooks/useAuthentication";
const CashierList = () => {
  const { control } = useForm({
    defaultValues: {
      searchDate: moment().format("YYYY-MM-DD"),
    },
  });
  const navigateTo = useNavigate();
  const [billedList, setBilledList] = useState<any>([]);
  console.log("billedList => ", billedList);

  const [searchPayload, setSearchPayload] = useState<getbilledItemPayloadType>({
    filter: {
      search: "",
      searchDate: moment().format("YYYY-MM-DD"),
    },
    pageNumber: 1,
    pageSize: 25,
    sortField: "",
    sortOrder: "asc",
  });
  const { mutate: getBilledList, isLoading } = useMutation(
    getBilledItemService,
    {
      onSuccess: (data) => {
        console.log("data in cachier => ", data);
        setBilledList(data?.response);
      },
    },
  );
  useEffect(() => {
    getBilledList(searchPayload);
  }, [searchPayload]);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const pageSize = parseInt(event.target.value, 10);
    setSearchPayload((prev) => ({
      ...prev,
      pageNumber: 1,
      pageSize,
    }));
  };
  const handleChangePage = (_: unknown, newPage: number) => {
    setSearchPayload((prev) => ({
      ...prev,
      pageNumber: newPage + 1, // backend expects 1-based page number
    }));
  };

  const searchOnText = debounce((e: FormOnChangeEventType) => {
    console.log(e.target.value);

    setSearchPayload((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        [e.target.name]: e.target.value,
      },
    }));
  }, 500);
  const searchAppointments = (e: FormOnChangeEventType) => {
    setSearchPayload((prev) => {
      const { filter } = prev;
      const { name, value } = e.target;

      const newValue =
        name === "searchDate" ? value : value?.id === 2 ? null : value?.id;

      return {
        ...prev,
        filter: {
          ...filter,
          [name]: newValue,
        },
      };
    });
  };

  // const { user } = useAuthentication();
  // const regionValue = user?.region;
  // const idHeading = regionValue === "QATAR_REGION" ? "Qatar ID" : "Emirates Id";
  const idHeading = "Civil ID";
  const headings = [
    "Sl No",
    "EMR No/Reg No",
    "Patient Name",
    idHeading,
    "BilledDate",
    "Time",
    "Bill No",
    "Amount",
    "invoice Print",
    "Action",
  ];
  const { printPdf } = usePrint()
  const { user } = useAuthentication()
  const { mutate: getPrint, isLoading: fileLoading } = useMutation(
    async ({ id, insName }: { id: number; insName: string }) => {
      console.log("user", user?.codetype)
      return user?.codetype === "CPT"
        ? (await getBillPrint(id)) : (await getBillPrintV2({
          insname: insName,
          clinicId: Number(user?.clinicId),
          encounterId: id,
        }));
    },
    {
      onSuccess: (result) => {
        // console.clear()
        if (result.responseIndicator == "success") {

          printPdf(result?.response?.invoice as string);
        }
      },
      onError: (error: any) => {
        console.log("error", error);
      },
    }
  );
  const [selected, setSelected] = useState<string | null>(null);
  const handlePrint = (e: any) => {
    const encounterId = e.currentTarget.getAttribute("data-patientid");
    const insName = e.currentTarget.getAttribute("data-insname");
    const index = e.currentTarget.getAttribute("data-index");
    setSelected(index);
    console.log("encounterId", encounterId)
    console.log("insName", insName)
    console.log("index", index)

    setSelected(index);

    getPrint({
      id: Number(encounterId),
      insName: insName || "",
    });
  };

  return (
    <>
      <form>
        <div className="grid grid-cols-12 gap-2 my-2">
          <div className="col-span-2">
            <CustomFormField
              control={control}
              element="input"
              name="search"
              rules={{ required: false, onChange: searchOnText }}
              fieldProps={{ label: "search", type: "text" }}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              element="datepicker"
              name="searchDate"
              dateFormat="YYYY-MM-DD"
              rules={{ required: false, onChange: searchAppointments }}
              fieldProps={{ label: "" }}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              element="autocomplete"
              options={[
                { id: 2, name: "All" },
                { id: 1, name: "Insurance" },
                { id: 0, name: "Cash" },
              ]}
              autocompleteProps={{
                getOptionLabel: (option) => option?.name || "",
                isOptionEqualToValue: (option, value) => {
                  if (!value) return false;
                  return option?.id === value?.id;
                },
              }}
              name="type"
              rules={{ required: false, onChange: searchAppointments }}
              fieldProps={{ label: "Payment Type" }}
            />
          </div>
        </div>
      </form>
      <Table
        size="small"
        sx={{
          "& .MuiTableCell-root": {
            border: "1px solid",
            borderColor: "divider",
          },
        }}
      >
        <TableHead
          sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
        >
          <TableRow>
            {headings.map((item: string) => {
              return (
                <TableCell
                  key={item}
                  align={item == "Action" || item == "invoice Print" ? "center" : "left"}
                  sx={(theme) => ({ color: theme.palette.background.paper })}
                >
                  {item}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>

        <CustomTableBody
          alert={"No Billed Items"}
          dataLoading={isLoading}
          isData={Boolean(billedList?.items?.length)}
          totalSpan={{ col: headings?.length, row: searchPayload.pageSize }}
        >
          {billedList?.items?.map((item: any, patientIndex: number) => {
            const rowSpan = item?.patientdetail?.length;
            return (
              <Fragment key={item.patientID}>
                {item?.patientdetail?.map(
                  (detail: any, detailIndex: number) => (
                    <TableRow key={detail.billingId}>
                      {detailIndex === 0 && (
                        <>
                          <TableCell rowSpan={rowSpan}>
                            {(searchPayload.pageNumber - 1) *
                              searchPayload.pageSize +
                              (patientIndex + 1)}
                          </TableCell>
                          <TableCell rowSpan={rowSpan}>
                            {item.patientID}
                          </TableCell>
                          <TableCell rowSpan={rowSpan}>
                            {item.patientName}
                          </TableCell>
                          <TableCell rowSpan={rowSpan}>
                            {item.emiratesID}
                          </TableCell>

                          <TableCell rowSpan={rowSpan}>
                            {item.createdDate}
                          </TableCell>
                        </>
                      )}
                      <TableCell>
                        {moment(detail.time, "HH:mm:ss").format("hh:mm A")}
                      </TableCell>
                      <TableCell>{detail.billingId}</TableCell>
                      <TableCell>
                        {Number(detail.patShare.toFixed(2))}
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title="Print" placement="left">
                          {(fileLoading) && selected === `${patientIndex}-${detailIndex}` ? (
                            <CircularProgress size={18} />
                          ) : (
                            <IconButton
                              disabled={fileLoading}
                              color="primary"
                              data-patientid={detail.encounterId}
                              data-index={`${patientIndex}-${detailIndex}`}
                              data-emrno={item.patientID}
                              // data-insname={item.}
                              onClick={handlePrint}
                            >
                              <LocalPrintshopIcon />
                            </IconButton>
                          )}
                        </Tooltip>
                      </TableCell>
                      {detailIndex === 0 && (
                        <TableCell rowSpan={rowSpan} align="center">
                          {(() => {
                            const totalPatShare = item?.patientdetail?.reduce(
                              (acc: number, detail: any) =>
                                acc + (Number(detail.patShare) || 0),
                              0,
                            );
                            const isPaid = totalPatShare <= 0;

                            return (
                              <IconButton
                                disabled={isPaid}
                                onClick={() =>
                                  navigateTo(
                                    `${base}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${patientCareRouteList.paymentv2}/${item.encounterID}/${item.patientMasterID}?emrno=${item.patientID}`,
                                  )
                                }
                              >
                                {isPaid ? (
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: "success.main",
                                      fontWeight: "bold",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    Paid
                                  </Typography>
                                ) : (
                                  <NoteAdd
                                    color="primary"
                                    sx={{ cursor: "pointer" }}
                                  />
                                )}
                              </IconButton>
                            );
                          })()}
                        </TableCell>
                      )}
                    </TableRow>
                  ),
                )}
              </Fragment>
            );
          })}
        </CustomTableBody>
      </Table>
      <TablePagination
        count={billedList?.totalCount || 0}
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPage={searchPayload.pageSize}
        page={(searchPayload.pageNumber || 1) - 1} // convert to 0-based
      />
    </>
  );
};

export default CashierList;
